import React from "react";
import { V2 } from "@idexcel-technologies-pvt-ltd/cync-los-common-components";
let { ConfirmModal } = V2;
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, showModal: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
      console.error(error, errorInfo);
      if (window.DD_RUM) {
          window.DD_RUM.addError('Page Crashed', {
            error: error.message,
            stack: error.stack,
            errorsource: 'error-boundary',
        });
      }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
            <ConfirmModal
                data-testid="error-boundary-modal"
                className="error-boundary-modal"
                show={this.state.hasError}
                onHide={() => this.setState({ hasError: false })}
                title="Something went wrong."
                text="The application has encountered an unexpected error. We apologize for the inconvenience."
                variant="danger"
                icon="faExclamationTriangle"
                confirm_text="Refresh"
                onConfirm={() => {
                    this.setState({ hasError: false });
                    window.location.reload();
                }}
            />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
